import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { SERVER_URL } from './ServerConfig'

class ChangePassword extends Component {
    notify = () => {
        toast.success("You password has been changed!", {
            position: toast.POSITION.TOP_CENTER
        });
    };

    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCurrentPasswordChange = this.handleCurrentPasswordChange.bind(this);
        this.handleNewPasswordChange = this.handleNewPasswordChange.bind(this);
        this.handleConfirmPasswordChange = this.handleConfirmPasswordChange.bind(this);

        this.state = {
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
            message : ''
        }
    }

    handleCurrentPasswordChange(event) {
        this.setState({ currentPassword: event.target.value });
    }

    handleNewPasswordChange(event) {
        this.setState({ newPassword: event.target.value });
    }

    handleConfirmPasswordChange(event) {
        this.setState({ confirmPassword: event.target.value });
    }

    handleSubmit(event) {
        event.preventDefault();
        if (!this.validToSubmit()) {
            return;
        }
        this.setState({message : ''});

        if (this.state.newPassword.length < 8 || this.state.newPassword.length > 100) {
            this.setState({ message : "Your password must be between 8 and 100 characters long"});
            return
        }

        const user = this.props.user.payload.user;
        const token = this.props.user.payload.token;
        let body = {
            oldPassword: this.state.currentPassword,
            newPassword: this.state.newPassword,
        };
        fetch(SERVER_URL + '/v1/users/' + user._id + '/changePassword', {
            method: 'post',
            headers: {
                'x-access-token': token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        }).then(response => {
            if (response.status === 403) {
                this.props.history.push("/login");
            } else {
                return response.json();
            }
        })
            .then(data => {
                if (data.success) {
                    this.setState({ currentPassword : '', newPassword : '', confirmPassword : '', message : ''});
                    this.notify();
                } else {
                    this.setState({ message : data.message});
                }
            });
    }

    validToSubmit() {
        return this.state.currentPassword.length > 0 
            && this.state.newPassword.length > 0 && this.state.confirmPassword.length > 0
            && this.state.newPassword === this.state.confirmPassword;
    }

    getSubmitButtonClass() {
        if (this.validToSubmit()) {
            return "btn btn-primary";
        }
        return "btn btn-primary disabled";
    }

    render() {
        return (
            <div>
                <div className="main-content">
                    <section className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1>Change Password</h1>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div className="m-2">
                        <section className="content col-sm-9">
                            <div className="card">
                                <div className="card-body">
                                    <div className="text-center">
                                        <p className="text-danger">{this.state.message}</p>
                                    </div>
                                    <form className="form-horizontal" onSubmit={this.handleSubmit}>
                                        <div className="form-group row">
                                            <label className="col-sm-2 col-form-label">Current Password</label>
                                            <div className="col-sm-10">
                                                <input type="password" className="form-control" autoComplete="off"
                                                    value={this.state.currentPassword} onChange={this.handleCurrentPasswordChange} />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-2 col-form-label">New Password</label>
                                            <div className="col-sm-10">
                                                <input type="password" className="form-control" autoComplete="off"
                                                    value={this.state.newPassword} onChange={this.handleNewPasswordChange} />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-2 col-form-label">Confirm Password</label>
                                            <div className="col-sm-10">
                                                <input type="password" className="form-control" autoComplete="off"
                                                    value={this.state.confirmPassword} onChange={this.handleConfirmPasswordChange} />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="offset-sm-2 col-sm-10">
                                                <button type="submit" className={this.getSubmitButtonClass()}>Update</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                        </section>

                    </div >
                    <ToastContainer />
                </div >

            </div>
        )
    }
}

export default ChangePassword;